// Avatar: a inicial da pessoa num círculo colorido.
//
// Existe para a lista deixar de ser um bloco de texto. Numa tabela de
// trinta atletas, o olho reencontra a linha pela mancha de cor muito antes
// de ler o nome de novo — e essa é a leitura que se faz o dia inteiro.
//
// A cor vem do nome (tema.js), não do perfil nem da situação. Cor que
// significa alguma coisa já existe na tela, na etiqueta de estado, e duas
// cores com dois significados na mesma linha não se leem.

import { corDoAvatar, iniciaisDoNome } from "../tema";

export default function Avatar({ nome, tamanho = 38, style = {} }) {
  const { bg, cor } = corDoAvatar(nome);
  return (
    <span
      title={nome || ""}
      style={{
        width: tamanho, height: tamanho, borderRadius: "50%",
        background: bg, color: cor,
        display: "inline-flex", alignItems: "center", justifyContent: "center",
        fontSize: Math.round(tamanho * 0.36), fontWeight: 700, letterSpacing: 0.2,
        flexShrink: 0, userSelect: "none", ...style,
      }}
    >
      {iniciaisDoNome(nome)}
    </span>
  );
}

// Avatar + nome + uma linha de apoio (e-mail, modalidade, categoria). É o
// bloco que aparece na primeira coluna de quase toda tabela do painel, e
// escrito à mão em cada tela acabava com um espaçamento diferente em cada.
export function PessoaNaLinha({ nome, apoio, tamanho = 38 }) {
  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 11, minWidth: 0 }}>
      <Avatar nome={nome} tamanho={tamanho} />
      <span style={{ minWidth: 0, lineHeight: 1.3 }}>
        <span style={{ display: "block", fontSize: 13.5, fontWeight: 600, color: "#1A2233", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
          {nome || "—"}
        </span>
        {apoio && (
          <span style={{ display: "block", fontSize: 12, color: "#64748B", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
            {apoio}
          </span>
        )}
      </span>
    </span>
  );
}
